export const USERS_LISTING_API = '/admin/users';
export const TEAM_MEMBERS_API = '/admin/team-members';
export const ASSIGN_SUBSCRIPTION_SALES_PERSON_API_FN = (id) => `/admin/subscriptions/${id}/sales-person`;
export const CLAIM_AD_FOR_OWNER_API_FN = (type, id) => `/admin/ads/${type}/${id}/claim-for-owner`;
export const PROPERTIES_LISTING_API = '/admin/property';
export const LOGIN_API = '/admin/login';
export const TOKEN_VERIFICATION_API = '/admin/verify-token';
export const ASSETS_PATH = 'https://assets.hexahome.in'
export const GET_USER_API_FN = (userId) => `/admin/users/${userId}`;

export const GET_PROPERTY_API_FN = (propertyType, propertyId) =>
  `/admin/${propertyType}/${propertyId}`;

export const UPDATE_USER_AND_PROPERTY_API = '/admin/update-status';
export const LOCALITY_INSIGHT_API = '/admin/locality-insights';
export const DOWNLOAD_SITEMAP_API = '/admin/download-sitemap';
export const LIMIT_EXHAUSTED_API = '/admin/limit-exhausted-users';
export const UPDATE_RECENT_SEARCH_PATH = '/admin/update-recent-search';

export const BUILDERS_LISTING_API = '/admin/builders';

export const AGENTS_LISTING_API = '/admin/agents';

export const ADS_LOCATION_API = '/location/autocomplete';

export const DASHBOARD_API = '/admin/dashboard/ads';

export const DASHBOARD_USER = '/admin/dashboard/users';

export const CREATE_USER = '/admin/users';
export const USER_ACTIVITY = '/admin/user-activity'
export const JOB_APPLICATIONS_API = '/admin/applied-jobs'

export const SEND_ASSIGNMENT_REMINDER_API = '/admin/send-reminder-mail'

export const DEV_ASSIGNEE_API = '/admin/dev-asignee'
export const UPDATE_ENTITY_PATH = '/admin/update-entity'

export const STATIC_DATA_PATH = '/static'
export const HEXAHOME_PATH = 'https://hexahome.in/'
/**post property routes**/ 
export const CREATE_ADS_API = '/admin/property';
export const GET_AUTO_COMPLETE = '/location/autosuggest';
export const AD_LEAD_API = '/admin/leads';
export const GET_LOCATION_DETAILS = '/location/place-detail';
export const ADS_UPLOAD_SIGNED_URL_API = '/admin/upload-signed-url/ad';
export const AUTO_GENERATE_DES_API = '/nlp/autogenerate-desc';
export const GET_STATIC_DATA_API = '/static/top-banks.json';
export const UPLOAD_SIGNED_PROJECTS_URL_API = '/admin/upload-signed-url/project';
export const CREATE_PROJECTS = '/admin/projects';
export const UPDATE_PROJECTS_STATUS = '/admin/projects/update-status';
export const CREATE_COMPANY = '/admin/company';
export const COMPANY_CERTIFICATE_UPLOAD_API = '/admin/upload-signed-url/certificate';
export const COMPANY_IMAGE_UPLOAD_API = '/admin/upload-signed-url/company-photo';
export const PROFILE_IMAGE_UPLOAD_PATH = '/admin/upload-signed-url/profile-photo';
export const STATIC_CONTENT_DATA_API = (relativePath) =>`/static${relativePath}`;
export const USER_REQUIREMENTS_API = '/admin/user-requirements';
export const BROKER_GROUP_API = '/admin/broker-group';
export const BROKER_GROUP_DETAILS = '/admin/broker-group-details';
export const SEND_LEAD_API = '/admin/send-lead';
export const APP_SETTINGS_API = '/admin/app-setting';
export const GET_PLANS = '/plans';
export const UPDATE_EXPIRY = '/admin/update-expiry';
export const EXPORT_USER = '/admin/export-users';
export const UPDATE_HOMEPAGE_DATA = '/admin/update-homepage-data';
export const USER_REQUEST_API = '/admin/user-requests';
export const USER_FEEDBACK_API = '/admin/user-feedbacks';
export const UPDATE_ROLE_API = '/admin/update-role';
export const USER_REPORT_API = '/admin/user-reports';
export const LOCALITY_OVERVIEW_API = '/admin/locality-overview';
export const UPDATE_EXPIRY_ALL = '/admin/update-expiry-all';
export const CHART_DATA_API = '/admin/data-chart';
export const SUBSCRIPTIONS_API = '/admin/subscriptions';
export const GET_SUBSCRIPTION_BY_ID = '/subscriptions/get-details';
export const UPDATE_SUBSCRIPTION = '/subscriptions/update';
export const ORDER_LISTING_API = '/admin/order-list';
export const ADD_PROPERTIES_API= '/admin/subscription/add-property';
export const PLAN_LIST_API = '/admin/plan-list';
export const FEATURES_LISTING_API='/plans/features';
export const GET_SINGLE_FEATURE='/plans/feature';
export const CREATE_PLAN_API='/plans';
export const PLAN_STATUS_UPDATE ='/admin/plan/update-status';
export const USER_USAGE_API='/admin/user-usage';
export const SHARE_PLANS_API='/admin/share-plan';
export const VIEW_NUMBER_USAGE='/admin/view-number-usage';
export const POST_TO_SOCIAL_MEDIA='/admin/post-to-social-media';
export const UPDATE_USER_REQUEST='/admin/update-user-requests';
export const UPDATE_USER_COMMENT='/admin/add-user-comment';
export const REVALIDATE_API='/api/revalidate/';
export const GET_CLASSIFIED_USER='/admin/classified_user';
export const GET_DIRECT_LEADS='/admin/get-direct-lead';
export const GET_DIRECT_LEADS_LIST='/admin/direct-leads';
export const GET_RECOMMENDED_PROPERTIES='/admin/get-recommended-properties';
export const SHARE_RECOMMENDED_PROPERTIES='/admin/share-recommended-properties';
export const SWITCH_PROPERTY_LEAD_AUTOMATION='/admin/property/update-lead-automation';
export const GET_SENT_PROPERTY_RECOMMENDATION='/admin/recommendations';
export const PAYMENT_LIST='/admin/payments';
export const PRICE_TRENDS_API='/price-trends/';
export const AGENT_PROJECT_MAPPING ='/admin/agent-project-mapping/';
